import "./LandingHero.scss";
import PropTypes from "prop-types";

/**
 * @param {Object} props
 * @param {string} props.description
 * @param {string} props.summary
 */
const LandingHero = ({ description, summary, price }) => {
  return (
    <div className="landing-hero">
      <div className="landing-hero__description">
        <div dangerouslySetInnerHTML={{ __html: description }} />
        <div>
          <p>¿Qué obtendrás?</p>
          <p dangerouslySetInnerHTML={{ __html: summary }} />
        </div>
      </div>
      <div className="landing-hero__price">
        <span>Precio por el servicio</span>
        <h1>{price}</h1>
        { price == "Pide presupuesto" ?
          <span>Pensamos que cada escritor y cada manuscrito son únicos, por ello te haremos una propuesta que se ajuste a tus necesidades</span>
        : <span>(Más 21% de IVA)</span> }  
      </div>
    </div>
  );
};
LandingHero.propTypes = {
  description: PropTypes.string,
  summary: PropTypes.string,
  price: PropTypes.string
};

export default LandingHero;
